var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsTooltip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "#AFAFAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3047 7.24219C11.4297 7.02344 11.5 6.76953 11.5 6.5C11.5 5.67188 10.8281 5 10 5C9.17188 5 8.5 5.67188 8.5 6.5C8.5 7.32812 9.17188 8 10 8C10.5586 8 11.0469 7.69531 11.3047 7.24219ZM9 9H9.5H10.5C11.0527 9 11.5 9.44727 11.5 10V11V15C11.5 15.5527 11.0527 16 10.5 16C9.94727 16 9.5 15.5527 9.5 15V11.75C9.5 11.3359 9.16406 11 8.75 11C8.33594 11 8 10.6641 8 10.25V10C8 9.64844 8.18164 9.33789 8.45508 9.16016C8.61133 9.05859 8.79883 9 9 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsTooltip);
export default __webpack_public_path__ + "static/media/accountsTooltip.04d669ea2975b675b8da1c9331f8fb09.svg";
export { ForwardRef as ReactComponent };